import React from "react";
import HeaderTop from "./HeaderTop";
import HeaderChatButton from "./HeaderChatButton";
import HeaderUserButton from "./HeaderUserButton";
import HeaderLangButton from "./HeaderLangButton";
import HeaderTasks from "./HeaderTasks";
import HeaderNotice from "./HeaderNotice";
import HeaderSearch from "./HeaderSearch";
import HeaderAdminButton from "./HeaderAdminButton";
import HeaderFavButton from "./HeaderFavButton";
import HeaderAssistantButton from "./HeaderAssistantButton";
import Sounds from "./Sounds";
import HeaderWorkdoc from "./HeaderWorkdoc";
import HeaderReportButton from "./HeaderReportButton";
function Header() {
  const headerLayout = window.appConfig.headerLayout || {};

  return (
    <div id="kt_header" className="header header-fixed">
      <Sounds />
      <div className="container-fluid  d-flex align-items-stretch justify-content-between">
        <div
          className="header-menu-wrapper header-menu-wrapper-left"
          id="kt_header_menu_wrapper"
        >
          <div
            id="kt_header_menu"
            className="header-menu header-menu-mobile  header-menu-layout-default"
          >
            <ul className="menu-nav">
              <li className="menu-item">
                <HeaderTop />
              </li>
            </ul>
          </div>
        </div>
        <div className="topbar">
          {headerLayout.search !== false && <HeaderSearch />}
          {headerLayout.admin !== false && <HeaderAdminButton />}
          {headerLayout.report !== false && <HeaderReportButton />}
          {headerLayout.tasks !== false && <HeaderTasks />}
          {headerLayout.workdoc !== false && <HeaderWorkdoc />}
          {headerLayout.notice !== false && <HeaderNotice />}
          {/**  <HeaderChatButton />*/}
          {headerLayout.assistant !== false && <HeaderAssistantButton />}
          {headerLayout.fav !== false && <HeaderFavButton />}
          <HeaderLangButton />
          <HeaderUserButton />
        </div>
      </div>
    </div>
  );
}
export default Header;
